export default __webpack_public_path__ + "static/media/icon-arrow-left.1f249be6.svg";